@if (value.length) {
  <span class="title">{{ control?.caption | translate }}</span>
}
<ul class="list-group" cdkDropList [cdkDropListData]="value" (cdkDropListDropped)="dropReorder($event)">
  @for (item of value; track item; let i = $index) {
    <li
      class="list-group-item"
      [ngClass]="{ 'read-only': control?.isReadonly }"
      cdkDrag
      cdkDragBoundary="ul"
      cdkDragLockAxis="y"
      >
      <span>{{ item }}</span>
      @if (!control.isReadonly) {
        <div class="controls">
          <svg _ngcontent-ng-c1626745506="" viewBox="0 0 100 100" height="35px" width="35px" cdkDragHandle>
            <defs>
              <marker id="arrow" viewBox="0 0 10 10" refX="5" refY="5" markerHeight="7" orient="auto-start-reverse" markerWidth="15">
                <path d="M 0 0 L 10 5 L 0 10 z"></path>
              </marker>
            </defs>
            <line x1="50" y1="30" x2="50" y2="70" stroke="black" marker-end="url(#arrow)" marker-start="url(#arrow)" stroke-width="3"></line>
          </svg>
          <button type="button" class="btn btn-delete" (click)="deleteItem(i)">&#10005;</button>
        </div>
      }
    </li>
  }
</ul>
@if (!control.isReadonly) {
  <form class="input" (submit)="addItem(innerControl.value)">
    <app-text-box [control]="innerControl"></app-text-box>
    <button type="submit" class="btn btn-active">{{ 'ADD_BTN' | translate }}</button>
  </form>
}
